import React, { Component } from 'react'
import Context from './Context'
import { TELEGRAM_THEME_VARS, mergeClasses } from './telegramTheme'
import './vendor/telegram-ui.css'
import './TelegramBadge.css'

const TYPE_CLASS = {
  number: 'tgui-562f7459d74103ea',
  dot: 'tgui-4f69ed647e40e245'
}

const MODE_CLASS = {
  primary: 'tgui-6e63faaa2b33f4ae',
  critical: 'tgui-4b52474c713ffa7c',
  secondary: 'tgui-0278f262d68294f0',
  gray: 'tgui-0883e451f3707277',
  white: 'tgui-6b3dbcedd9052940'
}

class TelegramBadge extends Component {
  static contextType = Context

  render () {
    const theme = this.context && this.context.theme === 'dark' ? 'dark' : 'light'

    const {
      type = 'number',
      mode = 'primary',
      large = false,
      value = '7',
      label,
      description,
    } = this.props

    const wrapperClassName = mergeClasses([
      'TelegramBadgeDemo',
      theme === 'dark' ? 'TelegramBadgeDemo--dark' : 'TelegramBadgeDemo--light'
    ])

    const badgeClassName = mergeClasses([
      'TelegramBadgePill',
      TYPE_CLASS[type] || TYPE_CLASS.number,
      MODE_CLASS[mode] || MODE_CLASS.primary,
      type === 'number' && large ? 'tgui-c1a5e9170826a773' : null,
    ])

    const labelClassName = mergeClasses([
      'TelegramBadgeLabel',
      theme === 'dark' ? 'TelegramBadgeLabel--dark' : null,
    ])

    const hintClassName = mergeClasses([
      'TelegramBadgeHint',
      theme === 'dark' ? 'TelegramBadgeHint--dark' : null,
    ])

    return (
      <div className={ wrapperClassName } style={{ ...TELEGRAM_THEME_VARS[theme] }}>
        <div className='TelegramBadgeLine'>
          <span className={ badgeClassName }>
            { type === 'number' &&
              <span className={ large ? 'TelegramBadgeTextLarge' : 'TelegramBadgeText' }>
                { value }
              </span>
            }
          </span>

          { label &&
            <span className={ labelClassName }>{ label }</span>
          }
        </div>

        { description &&
          <div className={ hintClassName }>{ description }</div>
        }
      </div>
    )
  }
}

export default TelegramBadge
